<template>
  <div class="job-header">
    <Transition>
      <div
        v-if="job.id"
        class="card d-flex flex-row justify-content-between px-3 py-3 flex-md-column flex-sm-column flex-xs-column flex-lg-row flex-wrap"
      >
        <div class="d-flex flex-column customer-info flex-1">
          <div class="d-flex justify-content-between">
            <h1 class="job-id page-header-1">
              Job
              <span class="font-weight-normal">#{{ job.id }}</span>
            </h1>
            <JobStatus v-if="jobStatusEnabled" :job="job" />
          </div>
          <div class="grid grid-cols-1 xl:grid-cols-3 gap-4">
            <CustomerInfo
              class="xl:col-span-2"
              :job="job"
              :customer="job.customer"
              hide-badges
              @edit-profile="goToProfile"
              @refresh-tax-info="handleRefreshTaxInfo"
            />
            <TagListCard class="xl:mt-8" @edit-profile="emit('edit-profile')" />
          </div>
        </div>
        <JobHeaderDetails />
      </div>
      <div
        v-else
        class="card px-3 py-3 d-flex align-items-center justify-content-center"
      >
        <Spinner message="Loading job details..." class="text-grey" />
      </div>
    </Transition>
  </div>
</template>

<script>
import { mapGetters, mapState } from "vuex";

import Spinner from "@/components/Spinner.vue";
import Transition from "@/components/Transition.vue";
import CustomerInfo from "@/Customer/CustomerInfo.vue";
import TagListCard from "../TagListCard.vue";
import JobHeaderDetails from "./JobHeaderDetails.vue";
import JobStatus from "./JobStatus.vue";

export default {
  name: "JobHeader",
  components: {
    Spinner,
    Transition,
    CustomerInfo,
    JobHeaderDetails,
    JobStatus,
    TagListCard
  },
  emits: ["refresh-job"],
  computed: {
    ...mapState(["job"]),
    ...mapGetters(["jobStatusEnabled"])
  },
  methods: {
    goToProfile() {
      this.$router.push(this.userShowPath(this.job.customer.id));
    },
    handleRefreshTaxInfo() {
      this.$emit("refresh-job");
    }
  },
  provide() {
    return {
      job: this.job
    };
  }
};
</script>

<style lang="scss" scoped>
.job-id {
  margin-bottom: 5px !important;
}
</style>
